var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.447,
    height: 14.388,
    viewBox: "0 0 14.447 14.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}.b{fill:#33475b;stroke:#33475b;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0.309 0.249)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.944,6.915l5.672-5.672A.728.728,0,1,0,12.586.214L6.914,5.886,1.242.214A.728.728,0,0,0,.213,1.243L5.885,6.915.213,12.587a.728.728,0,1,0,1.029,1.029L6.914,7.944l5.672,5.672a.728.728,0,1,0,1.029-1.029Z",
    transform: "translate(0 -0.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.830865e3351fa53cc5d296fe106ee827.svg";
export { ForwardRef as ReactComponent };